/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PrintContent/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Loading from './Loading/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function PrintContent({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Content/Content/Print/PrintContent",
  onSubmit,
  isSubmitting
  
}) {
let printSubmitData = fromData.useDataSubmit({ viewPath,
context: 'print',
})
let printIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'print',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 size="small"
 width="100%"
 data="print"
 onClick={printSubmitData}
 disabled={printIsSubmittingData}
 text="Print"
/>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
{children}
</React.Fragment>)
}